import axios from "axios";
import { Capacitor } from "@capacitor/core";

export const IS_NATIVE = typeof Capacitor !== "undefined" && Capacitor.isNativePlatform();
export const TOKEN_KEY = "np_token";

export const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  // Web is same-origin (cookies + CORS-safe). Native is cross-origin from the
  // webview, so it must be non-credentialed — it authenticates with Bearer tokens.
  withCredentials: !IS_NATIVE,
});

API.interceptors.request.use((config) => {
  if (IS_NATIVE) {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let refreshing = null;
API.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config || {};
    if (err.response?.status === 401 && !orig._retry && !(orig.url || "").includes("/auth/")) {
      orig._retry = true;
      refreshing = refreshing || API.post("/auth/refresh")
        .then((r) => {
          if (r.data?.access_token) localStorage.setItem(TOKEN_KEY, r.data.access_token);
        })
        .finally(() => { refreshing = null; });
      try {
        await refreshing;
        return API(orig);
      } catch {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export function mediaUrl(src) {
  if (!src) return src;
  if (src.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${src}`;
  return src;
}

export function fmtErr(e) {  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && x.msg) || JSON.stringify(x)).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export function trackAnalytics(type, venue_id, event_id = null) {
  API.post("/analytics/track", { type, venue_id, event_id }).catch(() => {});
}
